import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToHash = () => {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) return;

        const id = location.hash.replace("#", "");
        let attempts = 0;
        const maxAttempts = 20;

        const checkAndScroll = () => {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
                return true;
            }
            return false;
        };

        // Retry until element exists
        const interval = setInterval(() => {
            if (checkAndScroll() || attempts >= maxAttempts) {
                clearInterval(interval);
            }
            attempts++;
        }, 100);

    }, [location]);
};
